import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  formatThousands: PropTypes.bool,
  thousandsSeparator: PropTypes.string,
};

function formatThousandsValue(value, separator) {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export default function RHFTextField({
  name,
  formatThousands = false,
  thousandsSeparator = '.',
  onBlur,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={
            formatThousands
              ? formatThousandsValue(field.value, thousandsSeparator)
              : field.value
          }
          onChange={(event) => {
            if (!formatThousands) {
              field.onChange(event);
              return;
            }

            field.onChange(event.target.value.replace(/\D/g, ''));
          }}
          onBlur={(event) => {
            field.onBlur();
            onBlur?.(event);
          }}
          error={!!error}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
